.icon {
  display: inline-flex;
}
